<app-form11-sidebar
  [currentStep]="currentStep"
  [stepsCovered]="this.stepsCovered"
  [hideSteps]="hideSteps"
  (currentStepEvent)="handleCurrentStepEvent($event)"
></app-form11-sidebar>
<form [formGroup]="formGroup">
  <section *ngIf="currentStep == 1 && !isUploadDocumentsPageHidden()">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12 udsmain">
          <div class="col-12 udprog">
            <div class="udslide">
              <div class="up20"></div>
            </div>
            <div class="udperc">
              <span class="udp2">20% completed</span>
            </div>
          </div>
          <div class="col-12 ulpg-mincnt">
            <div class="row">
              <div class="col-md-12 mb-2 empl-tptxt">
                <h3>Welcome ! Let's get started by uploading Aadhaar and PAN copy</h3>
              </div>
              <div class="row g-3 mx-0 justify-content-md-center">
                <div class="col-md-6 col-12" *ngIf="!isFieldHidden('UPLOAD_AADHAAR_FRONT')">
                  <div class="p-3 text-center">
                    <div class="col-12 text-center upladtp-txt">
                      <h3>Upload Aadhaar Front Side <sup *ngIf="isFieldMandatory('UPLOAD_AADHAAR_FRONT')">*</sup></h3>
                    </div>
                    <div #aadharFront id="images-show">
                      <img src="./assets/images/aadhaar-front.png" class="img-fluid" />
                    </div>
                    <app-multiple-file-selector
                      [isMultiple]="false"
                      [acceptedFormatMsg]="acceptedFormat"
                      [inputAccept]="'.jpeg, .jpg, .png'"
                      [allowedTypes]="['image/jpeg', 'image/png']"
                      (chooseFiles)="onChooseFile($event, aadharFrontRef); uploadedFiles.aadhaarFront = $event?.[0]"
                    ></app-multiple-file-selector>
                  </div>
                </div>
                <div class="col-md-6 col-12" *ngIf="!isFieldHidden('UPLOAD_AADHAAR_BACK')">
                  <div class="p-3 text-center">
                    <div class="col-12 text-center upladtp-txt">
                      <h3>Upload Aadhaar Back Side <sup *ngIf="isFieldMandatory('UPLOAD_AADHAAR_BACK')">*</sup></h3>
                    </div>
                    <div #aadharBack id="images-show1">
                      <img src="./assets/images/aadhaar-back.png" class="img-fluid" />
                    </div>
                    <app-multiple-file-selector
                      [isMultiple]="false"
                      [acceptedFormatMsg]="acceptedFormat"
                      [inputAccept]="'.jpeg, .jpg, .png'"
                      [allowedTypes]="['image/jpeg', 'image/png']"
                      (chooseFiles)="onChooseFile($event, aadharBackRef); uploadedFiles.aadhaarBack = $event?.[0]"
                    ></app-multiple-file-selector>
                  </div>
                </div>
                <div class="col-md-6 col-12" *ngIf="!isFieldHidden('UPLOAD_PAN')">
                  <div class="p-3 text-center">
                    <div class="col-12 text-center upladtp-txt">
                      <h3>Upload PAN Card <sup *ngIf="isFieldMandatory('UPLOAD_PAN')">*</sup></h3>
                    </div>
                    <div #panCard id="images-show2">
                      <img src="./assets/images/pan-crd.png" class="img-fluid" />
                    </div>
                    <app-multiple-file-selector
                      [isMultiple]="false"
                      [acceptedFormatMsg]="acceptedFormat"
                      [inputAccept]="'.jpeg, .jpg, .png'"
                      [allowedTypes]="['image/jpeg', 'image/png']"
                      (chooseFiles)="onChooseFile($event, panCardRef); uploadedFiles.pan = $event?.[0]"
                    ></app-multiple-file-selector>
                  </div>
                </div>
                <div class="col-md-6 col-12">
                  <div class="p-3 text-center"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid px-0">
      <div class="row d-flex justify-content-end p-3 udbtm mx-0">
        <div class="col-md-12 col-12">
          <ul>
            <li>
              <button
                type="button"
                class="btn scbtn margin-right-10"
                (click)="goToDashboard()"
                [routerLink]="dashboardPageLink"
              >
                <i class="fas fa-arrow-left"></i> EXIT TO DASHBOARD
              </button>
            </li>
            <li>
              <button
                type="button"
                class="btn scbtn margin-right-10"
                (click)="goToNewJoineeActivity()"
                [routerLink]="dashboardPageLink"
              >
                <i class="fas fa-arrow-left"></i> GO TO NEW JOINEE ACTIVITY
              </button>
            </li>
            <li>
              <button type="button" class="btn scbtn" [disabled]="!isAadhaarAndPanUploaded" (click)="moveTo(2)">
                UPLOAD AND NEXT <i class="fas fa-arrow-right"></i>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section *ngIf="currentStep == 2 && !isPersonalDetailsPageHidden()">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12 udsmain">
          <div class="col-12 udprog">
            <div class="udslide">
              <div class="up40"></div>
            </div>
            <div class="udperc">
              <span class="udp4">40% completed</span>
            </div>
          </div>
          <div class="col-12 prsnldtl-mincnt">
            <div class="row">
              <div class="col-md-12 mb-2 empl-tptxt">
                <h3>Let us now fill up the personal information</h3>
              </div>
              <div formGroupName="personalInfo" class="col-md-7 col-12 my-3">
                <div class="row mx-0">
                  <div class="col-12 mb-3" *ngIf="!isFieldHidden('NAME_AS_IN_AADHAAR')">
                    <div class="col-md-6 col-8 pe-md-3">
                      <label for="inputEmail4" class="form-label"
                        >Name as in Aadhaar <sup *ngIf="isFieldMandatory('NAME_AS_IN_AADHAAR')">*</sup>
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        aria-label="First name"
                        [formControlName]="NAME_AS_PER_AADHAAR"
                        onkeydown="return /[a-zA-Z\s]/i.test(event.key)"
                        [ngClass]="{
                          'is-invalid':
                            getControl('personalInfo.nameAsPerAadhaar').errors &&
                            getControl('personalInfo.nameAsPerAadhaar').touched
                        }"
                        maxlength="75"
                      />
                      <app-validation
                        field="personalInfo.nameAsPerAadhaar"
                        [form]="formGroup"
                        [error]="{
                          required: 'This is a mandatory field, Kindly enter name',
                          pattern: 'Invalid Name',
                          maxLength: 'Name should not exceed 75 characters'
                        }"
                      ></app-validation>
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mb-3" *ngIf="!isFieldHidden('YOUR_DATE_OF_BIRTH')">
                    <label for="inputEmail4" class="form-label"
                      >Your Date of Birth <sup *ngIf="isFieldMandatory('YOUR_DATE_OF_BIRTH')">*</sup>
                    </label>
                    <input
                      type="date"
                      class="form-control"
                      aria-label="Last name"
                      formControlName="dob"
                      max="{{ today }}"
                      [ngClass]="{
                        'is-invalid': getControl('personalInfo.dob').errors && getControl('personalInfo.dob').touched
                      }"
                    />
                    <app-validation
                      field="personalInfo.dob"
                      [form]="formGroup"
                      [error]="{
                        required: 'This is a mandatory field, Kindly select Date of Birth',
                        invalidDob: 'The age you have mentioned is less than 14 years. Recheck and enter correct DOB.',
                        futureDate: 'Future days are restricted. Recheck and enter correct DOB.'
                      }"
                    ></app-validation>
                  </div>
                  <div class="col-md-6 col-12 mb-3" *ngIf="!isFieldHidden('GENDER')">
                    <label for="inputEmail4" class="form-label"
                      >Gender <sup *ngIf="isFieldMandatory('GENDER')">*</sup>
                    </label>
                    <select
                      id="inputState"
                      class="form-select"
                      formControlName="gender"
                      [ngClass]="{
                        'is-invalid':
                          getControl('personalInfo.gender').errors && getControl('personalInfo.gender').touched
                      }"
                    >
                      <option [selected]="true" value="">Select Gender</option>
                      <option *ngFor="let gender of genders" [value]="gender?.key1?.toUpperCase()">
                        {{ gender?.key2 }}
                      </option>
                    </select>
                    <app-validation
                      field="personalInfo.gender"
                      [form]="formGroup"
                      [error]="{ required: 'This is a mandatory field, Kindly select Gender' }"
                    ></app-validation>
                  </div>
                  <div class="col-md-6 col-12 mb-3" *ngIf="!isFieldHidden('PAN_NUMBER')">
                    <label for="inputEmail4" class="form-label"
                      >PAN Number <sup *ngIf="isFieldMandatory('PAN_NUMBER')">*</sup>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      aria-label="Last name"
                      formControlName="panNumber"
                      (input)="onInputChange($event)"
                      [(ngModel)]="panNumberValue"
                      [ngClass]="{
                        'is-invalid':
                          getControl('personalInfo.panNumber').errors && getControl('personalInfo.panNumber').touched
                      }"
                    />
                    <app-validation
                      field="personalInfo.panNumber"
                      [form]="formGroup"
                      [error]="{
                        required: 'This is a mandatory field, Kindly enter PAN number',
                        invalid: 'Invalid PAN format'
                      }"
                    ></app-validation>
                  </div>
                  <div class="col-md-6 col-12 mb-3" *ngIf="!isFieldHidden('AADHAAR_NUMBER')">
                    <label for="inputEmail4" class="form-label"
                      >Aadhaar Number <sup *ngIf="isFieldMandatory('AADHAAR_NUMBER')">*</sup>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      aria-label="Last name"
                      formControlName="aadhaarNumber"
                      (input)="onInput($event)"
                      [ngClass]="{
                        'is-invalid':
                          getControl('personalInfo.aadhaarNumber').errors &&
                          getControl('personalInfo.aadhaarNumber').touched
                      }"
                      maxlength="12"
                    />
                    <app-validation
                      field="personalInfo.aadhaarNumber"
                      [form]="formGroup"
                      [error]="{
                        required: 'This is a mandatory field, Kindly enter Aadhaar number',
                        invalid: 'Invalid Aadhaar format'
                      }"
                    ></app-validation>
                  </div>
                  <div class="col-md-6 col-12 mb-3" *ngIf="!isFieldHidden('FATHER_NAME')">
                    <label for="inputEmail4" class="form-label"
                      >Father’s Name <sup *ngIf="isFieldMandatory('FATHER_NAME')">*</sup>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      aria-label="Last name"
                      formControlName="fatherName"
                      onkeydown="return /[a-zA-Z\s]/i.test(event.key)"
                      [ngClass]="{
                        'is-invalid':
                          getControl('personalInfo.fatherName').errors && getControl('personalInfo.fatherName').touched
                      }"
                      maxLength="75"
                    />
                    <app-validation
                      field="personalInfo.fatherName"
                      [form]="formGroup"
                      [error]="{
                        required: 'This is a mandatory field, Kindly enter Father name',
                        pattern: 'Invalid Name',
                        maxLength: 'Father’s Name should not exceed 75 characters'
                      }"
                    ></app-validation>
                  </div>
                  <div class="col-md-6 col-12 mb-3" *ngIf="!isFieldHidden('MARITAL_STATUS')">
                    <label for="inputEmail4" class="form-label"
                      >Marital Status <sup *ngIf="isFieldMandatory('MARITAL_STATUS')">*</sup>
                    </label>
                    <select
                      id="inputState"
                      class="form-select"
                      formControlName="maritalStatus"
                      [ngClass]="{
                        'is-invalid':
                          getControl('personalInfo.maritalStatus').errors &&
                          getControl('personalInfo.maritalStatus').touched
                      }"
                    >
                      <option [disabled]="true" [selected]="true" value="">Select Marital Status</option>
                      <option
                        *ngFor="let maritalStatus of maritalStatuses"
                        [value]="maritalStatus?.key1?.toUpperCase()"
                      >
                        {{ maritalStatus?.key2 }}
                      </option>
                    </select>
                    <app-validation
                      field="personalInfo.maritalStatus"
                      [form]="formGroup"
                      [error]="{ required: 'This is a mandatory field, Kindly select marital status' }"
                    ></app-validation>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid px-0">
      <div class="row d-flex justify-content-end p-3 udbtm mx-0">
        <div class="col-md-9 col-12">
          <ul>
            <li>
              <button
                type="button"
                class="btn scbtn margin-right-10"
                (click)="goToDashboard()"
                [routerLink]="dashboardPageLink"
              >
                <i class="fas fa-arrow-left"></i> EXIT TO DASHBOARD
              </button>
            </li>
            <li *ngIf="!isUploadDocumentsPageHidden()">
              <button type="button" class="btn psbtn margin-right-10" (click)="moveTo(1)">
                <i class="fas fa-arrow-left"></i> PREVIOUS SECTION
              </button>
            </li>
            <li>
              <button type="button" class="btn scbtn" (click)="moveTo(3)">
                CONTINUE <i class="fas fa-arrow-right"></i>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section *ngIf="currentStep == 3 && !isContactInfoPageHidden()">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12 udsmain">
          <div class="col-12 udprog">
            <div class="udslide">
              <div class="up60"></div>
            </div>
            <div class="udperc">
              <span class="udp6">60% completed</span>
            </div>
          </div>
          <div formGroupName="contactInfo" class="col-12 prsnldtl-mincnt" *ngIf="!isFieldHidden('CONTACT_DETAILS')">
            <div class="row">
              <div class="col-md-12 mb-2 empl-tptxt">
                <h3>Now it's time to complete the contact details</h3>
              </div>
              <div class="col-md-12 col-12 my-3">
                <div class="row">
                  <div class="col-4" *ngIf="!isFieldHidden('MOBILE_NUMBER')">
                    <div class="mb-3 mobile-number-block">
                      <label for="exampleFormControlInput1" class="form-label"
                        >Mobile Number <sup *ngIf="isFieldMandatory('MOBILE_NUMBER')">*</sup></label
                      >
                      <div class="mobile-input-group">
                        <select formControlName="primaryCountryCode" class="form-control">
                          <option *ngFor="let countryCode of countryCodes">{{ countryCode.dialCode }}</option>
                        </select>

                        <input
                          type="text"
                          placeholder=""
                          formControlName="primaryMobileNumber"
                          onkeydown="return /[0-9]/i.test(event.key) || event.key === 'Backspace' || event.key === 'ArrowLeft' || event.key === 'ArrowRight'"
                          class="form-control form-control-fixed-phone mobile-number-input"
                          [ngClass]="{
                            'is-invalid':
                              getControl('contactInfo.primaryMobileNumber').errors &&
                              getControl('contactInfo.primaryMobileNumber').touched
                          }"
                          maxlength="10"
                        />
                      </div>
                      <app-validation
                        field="contactInfo.primaryMobileNumber"
                        [form]="formGroup"
                        [error]="{
                          required: 'This is a mandatory field, Kindly enter Primary Mobile Number',
                          invalid: 'Please enter a 10-digit mobile number'
                        }"
                      ></app-validation>
                    </div>
                  </div>
                  <div class="col-md-4 col-12 mb-3" *ngIf="!isFieldHidden('EMAIL_ID')">
                    <label for="emid" class="form-label"
                      >Email ID (Personal Email ID) <sup *ngIf="isFieldMandatory('EMAIL_ID')">*</sup>
                    </label>
                    <input
                      type="email"
                      class="form-control"
                      aria-label="Email ID"
                      formControlName="secondaryEmailId"
                      onkeydown="return /[0-9a-zA-Z@.]/i.test(event.key)"
                      [ngClass]="{
                        'is-invalid':
                          getControl('contactInfo.secondaryEmailId').errors &&
                          getControl('contactInfo.secondaryEmailId').touched
                      }"
                      maxlength="75"
                    />
                    <app-validation
                      field="contactInfo.secondaryEmailId"
                      [form]="formGroup"
                      [error]="{
                        required: 'This is a mandatory field, Kindly enter E-Mail ID',
                        minLength: 'E-Mail ID should have a minimum of 5 characters',
                        maxLength: 'E-Mail ID should not exceed 75 characters',
                        email: 'Invalid email format'
                      }"
                    ></app-validation>
                  </div>
                </div>
                <ng-container *ngIf="!isFieldHidden('PERMANENT_ADDRESS')">
                  <div class="row">
                    <div class="col-12">
                      <label class="form-label"
                        >Permanent Address <sup *ngIf="isFieldMandatory('PERMANENT_ADDRESS')">*</sup>
                      </label>
                    </div>
                  </div>
                  <div formGroupName="permanentAddress">
                    <div class="row">
                      <div class="col-md-4 col-12 mb-3">
                        <label for="dono" class="form-label"
                          >Door No <sup *ngIf="isFieldMandatory('PERMANENT_ADDRESS')">*</sup>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          aria-label="Door No"
                          formControlName="address1"
                          onkeydown="return /[0-9a-zA-Z#,-/\s]/i.test(event.key)"
                          [ngClass]="{
                            'is-invalid':
                              getControl('contactInfo.permanentAddress.address1').errors &&
                              getControl('contactInfo.permanentAddress.address1').touched
                          }"
                        />
                        <app-validation
                          field="contactInfo.permanentAddress.address1"
                          [form]="formGroup"
                          [error]="{
                            required: 'This is a mandatory field, Kindly enter Door No',
                            pattern: 'Invalid Door No.'
                          }"
                        ></app-validation>
                      </div>
                      <div class="col-md-4 col-12 mb-3">
                        <label for="stna" class="form-label"
                          >Street Name <sup *ngIf="isFieldMandatory('PERMANENT_ADDRESS')">*</sup>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          aria-label="Street Name"
                          formControlName="address2"
                          onkeydown="return /[a-zA-Z0-9\s]/i.test(event.key)"
                          [ngClass]="{
                            'is-invalid':
                              getControl('contactInfo.permanentAddress.address2').errors &&
                              getControl('contactInfo.permanentAddress.address2').touched
                          }"
                        />
                        <app-validation
                          field="contactInfo.permanentAddress.address2"
                          [form]="formGroup"
                          [error]="{
                            required: 'This is a mandatory field, Kindly Street Name',
                            pattern: 'Invalid Street Name'
                          }"
                        ></app-validation>
                      </div>
                      <div class="col-md-4 col-12 mb-3">
                        <label for="area" class="form-label"
                          >Area <sup *ngIf="isFieldMandatory('PERMANENT_ADDRESS')">*</sup>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          aria-label="Area"
                          formControlName="address3"
                          onkeydown="return /[A-Za-z]/i.test(event.key)"
                          [ngClass]="{
                            'is-invalid':
                              getControl('contactInfo.permanentAddress.address3').errors &&
                              getControl('contactInfo.permanentAddress.address3').touched
                          }"
                        />
                        <app-validation
                          field="contactInfo.permanentAddress.address3"
                          [form]="formGroup"
                          [error]="{ required: 'This is a mandatory field, Kindly enter area' }"
                        ></app-validation>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4 col-12 mb-3">
                        <label for="city" class="form-label"
                          >City <sup *ngIf="isFieldMandatory('PERMANENT_ADDRESS')">*</sup>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          aria-label="City"
                          formControlName="city"
                          onkeydown="return /[a-zA-Z]/i.test(event.key)"
                          [ngClass]="{
                            'is-invalid':
                              getControl('contactInfo.permanentAddress.city').errors &&
                              getControl('contactInfo.permanentAddress.city').touched
                          }"
                        />
                        <app-validation
                          field="contactInfo.permanentAddress.city"
                          [form]="formGroup"
                          [error]="{ required: 'This is a mandatory field, Kindly enter city' }"
                        ></app-validation>
                      </div>
                      <div class="col-md-4 col-12 mb-3">
                        <label for="state" class="form-label"
                          >State <sup *ngIf="isFieldMandatory('PERMANENT_ADDRESS')">*</sup>
                        </label>
                        <select
                          id="inputState"
                          class="form-select"
                          formControlName="state"
                          onkeydown="return /[A-Za-z]/i.test(event.key)"
                          [ngClass]="{
                            'is-invalid':
                              getControl('contactInfo.permanentAddress.state').errors &&
                              getControl('contactInfo.permanentAddress.state').touched
                          }"
                        >
                          <option [selected]="true" value="">Select State</option>
                          <option *ngFor="let state of states" value="{{ state?.key1 }}">{{ state?.key2 }}</option>
                        </select>
                        <app-validation
                          field="contactInfo.permanentAddress.state"
                          [form]="formGroup"
                          [error]="{ required: 'This is a mandatory field, Kindly select state' }"
                        ></app-validation>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4 col-12 mb-3">
                        <label for="country" class="form-label"
                          >Country <sup *ngIf="isFieldMandatory('PERMANENT_ADDRESS')">*</sup>
                        </label>
                        <select
                          id="inputState"
                          class="form-select"
                          formControlName="country"
                          [ngClass]="{
                            'is-invalid':
                              getControl('contactInfo.permanentAddress.country').errors &&
                              getControl('contactInfo.permanentAddress.country').touched
                          }"
                        >
                          <option [selected]="true" value="">Select Country</option>
                          <option *ngFor="let country of countries" [value]="country.name">{{ country.name }}</option>
                        </select>
                        <app-validation
                          field="contactInfo.permanentAddress.country"
                          [form]="formGroup"
                          [error]="{ required: 'This is a mandatory field, Kindly select country' }"
                        ></app-validation>
                      </div>
                      <div class="col-md-4 col-12 mb-3">
                        <label for="pin" class="form-label"
                          >Pincode <sup *ngIf="isFieldMandatory('PERMANENT_ADDRESS')">*</sup>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          aria-label="Pincode"
                          formControlName="pin"
                          (input)="onInput($event)"
                          [ngClass]="{
                            'is-invalid':
                              getControl('contactInfo.permanentAddress.pin').errors &&
                              getControl('contactInfo.permanentAddress.pin').touched
                          }"
                          maxlength="6"
                        />
                        <app-validation
                          field="contactInfo.permanentAddress.pin"
                          [form]="formGroup"
                          [error]="{
                            required: 'This is a mandatory field, Kindly enter pincode',
                            invalid: 'Invalid Pincode format'
                          }"
                        ></app-validation>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid px-0">
      <div class="row d-flex justify-content-end p-3 udbtm mx-0">
        <div class="col-md-9 col-12">
          <ul>
            <li>
              <button
                type="button"
                class="btn scbtn margin-right-10"
                (click)="goToDashboard()"
                [routerLink]="dashboardPageLink"
              >
                <i class="fas fa-arrow-left"></i> EXIT TO DASHBOARD
              </button>
            </li>
            <li>
              <button type="button" class="btn psbtn margin-right-10" (click)="moveTo(2)">
                <i class="fas fa-arrow-left"></i> PREVIOUS SECTION
              </button>
            </li>
            <li>
              <button type="button" class="btn scbtn" (click)="moveTo(4)">
                CONTINUE <i class="fas fa-arrow-right"></i>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section *ngIf="currentStep == 4">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12 udsmain">
          <div class="col-12 udprog">
            <div class="udslide">
              <div class="up80"></div>
            </div>
            <div class="udperc">
              <span class="udp8">80% completed</span>
            </div>
          </div>
          <div class="col-12 epfo-mincnt">
            <div class="row">
              <div class="col-md-12 mb-2 empl-tptxt">
                <h3>Well done untill now, Let's keep going</h3>
              </div>
              <div class="col-md-12 col-12 px-0">
                <div formGroupName="passportDetails" *ngIf="!isFieldHidden('PASSPORT_DETAILS')">
                  <div class="row mx-0">
                    <div class="col-md-6 col-12 mb-3 align-self-center rdobtn-dv">
                      <p>Are you already an International Worker ?</p>
                    </div>
                    <div class="col-md-5 col-12 mb-3 align-self-center px-0">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="isInternationalWorker"
                          [value]="true"
                          id="isInternationalWorker-yes"
                          formControlName="isInternationalWorker"
                        />
                        <label class="form-check-label" for="isInternationalWorker"> Yes <sup>*</sup> </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          name="isInternationalWorker"
                          [value]="false"
                          id="isInternationalWorker-no"
                          formControlName="isInternationalWorker"
                        />
                        <label class="form-check-label" for="isInternationalWorker"> No <sup>*</sup> </label>
                      </div>
                    </div>
                  </div>
                  <div class="row mx-0" *ngIf="f?.['passportDetails']?.controls?.['isInternationalWorker']?.value">
                    <div class="col-md-3 col-12 mb-3">
                      <label for="inputEmail4" class="form-label"
                        >Country of Origin <sup *ngIf="isFieldMandatory('PASSPORT_DETAILS')">*</sup>
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        aria-label="Last name"
                        formControlName="countryOfOrigin"
                        onkeydown="return /[A-Za-z]/i.test(event.key)"
                        [ngClass]="{
                          'is-invalid':
                            getControl('passportDetails.countryOfOrigin').errors &&
                            getControl('passportDetails.countryOfOrigin').touched
                        }"
                      />
                      <app-validation
                        field="passportDetails.countryOfOrigin"
                        [form]="formGroup"
                        [error]="{ required: 'This is a mandatory field, Kindly enter country of origin' }"
                      ></app-validation>
                    </div>
                    <div class="col-md-3 col-12 mb-3">
                      <label for="inputEmail4" class="form-label"
                        >Passport Number <sup *ngIf="isFieldMandatory('PASSPORT_DETAILS')">*</sup>
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        aria-label="Last name"
                        formControlName="passportNumber"
                        onkeydown="return /[0-9a-zA-Z]/i.test(event.key)"
                        [ngClass]="{
                          'is-invalid':
                            getControl('passportDetails.passportNumber').errors &&
                            getControl('passportDetails.passportNumber').touched
                        }"
                        maxlength="20"
                      />
                      <app-validation
                        field="passportDetails.passportNumber"
                        [form]="formGroup"
                        [error]="{
                          required: 'This is a mandatory field, Kindly enter passport number',
                          invalid: 'Please enter a valid Passport Number'
                        }"
                      ></app-validation>
                    </div>
                    <div class="col-md-6 col-12 mb-3">
                      <div class="row mx-0">
                        <div class="col-6 mb-3">
                          <label for="inputEmail4" class="form-label"
                            >Valid From <sup *ngIf="isFieldMandatory('PASSPORT_DETAILS')">*</sup>
                          </label>
                          <input
                            type="date"
                            class="form-control"
                            aria-label="First name"
                            formControlName="validFrom"
                            [ngClass]="{
                              'is-invalid':
                                getControl('passportDetails.validFrom').errors &&
                                getControl('passportDetails.validFrom').touched
                            }"
                          />
                          <app-validation
                            field="passportDetails.validFrom"
                            [form]="formGroup"
                            [error]="{
                              required: 'This is a mandatory field, Kindly select passport valid from date',
                              invalid: 'Valid From cannot be in future'
                            }"
                          ></app-validation>
                        </div>
                        <div class="col-6 mb-3">
                          <label for="inputEmail4" class="form-label"
                            >Valid Till <sup *ngIf="isFieldMandatory('PASSPORT_DETAILS')">*</sup>
                          </label>
                          <input
                            type="date"
                            class="form-control"
                            aria-label="Last name"
                            formControlName="validTill"
                            [ngClass]="{
                              'is-invalid':
                                getControl('passportDetails.validTill').errors &&
                                getControl('passportDetails.validTill').touched
                            }"
                          />
                          <app-validation
                            field="passportDetails.validTill"
                            [form]="formGroup"
                            [error]="{
                              required: 'This is a mandatory field, Kindly select passport valid till date',
                              invalid: 'Valid Till date must be in the future'
                            }"
                          ></app-validation>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="col-12 right-notfctn">
                        <img
                          src="../../../assets/images/svg/calendar-icon.svg"
                          style="float: left; height: 17px; margin-top: 4px"
                        />
                        <span style="display: inline-block">Note :</span>
                        <div
                          class="note"
                          style="display: inline-block; padding-left: 5px"
                          *ngFor="let note of configMap.get('INTERNATIONAL_WORKER_NOTES')?.split('~~~')"
                          [innerHTML]="note"
                        ></div>
                      </div>
                    </div>
                    <div #passport class="col-md-6 col-12 px-0">
                      <div class="p-3 text-center">
                        <div class="col-12 text-start upladtp-txt">
                          <h3>Upload your Passport Copy <sup *ngIf="isPassportUploadMandatory">*</sup></h3>
                        </div>
                        <app-multiple-file-selector
                          [isMultiple]="false"
                          [acceptedFormatMsg]="passportFileAcceptedFormatMsg"
                          [inputAccept]="'.pdf, .jpeg, .jpg, .png'"
                          [allowedTypes]="['application/pdf', 'image/jpeg', 'image/png']"
                          (chooseFiles)="uploadedFiles.passport = $event?.[0]"
                        ></app-multiple-file-selector>
                      </div>
                    </div>
                    <div class="col-md-4 col-12 px-0">
                      <div id="images-show3" class="p-3"></div>
                    </div>
                  </div>
                </div>

                <div class="col-xxl-12 col-xl-12 col-lg-9 col-md-7 col-12 px-0 my-3">
                  <div class="row mx-0" formGroupName="epfDetails">
                    <div class="col-md-6 col-12 mb-3 align-self-center rdobtn-dv">
                      <p>Are you already a member of EPF ?</p>
                    </div>
                    <div class="col-md-6 col-12 mb-3 align-self-center px-0">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="epf-member-yes"
                          [value]="true"
                          formControlName="isExistingEPFMember"
                        />
                        <label class="form-check-label" for="epf-member"> Yes <sup>*</sup> </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="epf-member-no"
                          [value]="false"
                          formControlName="isExistingEPFMember"
                        />
                        <label class="form-check-label" for="epf-member"> No <sup>*</sup> </label>
                      </div>
                    </div>
                    <div class="row mx-0" *ngIf="f?.['epfDetails']?.controls?.['isExistingEPFMember']?.value">
                      <div class="row px-0">
                        <div class="col-md-6 col-12 mb-3">
                          <label for="inputEmail4" class="form-label">UAN Number <sup>*</sup> </label>
                          <input
                            type="text"
                            class="form-control"
                            aria-label="Last name"
                            formControlName="uanNumber"
                            (input)="validateUAN($event)"
                            [ngClass]="{
                              'is-invalid':
                                getControl('epfDetails.uanNumber').errors && getControl('epfDetails.uanNumber').touched
                            }"
                            maxlength="12"
                          />
                          <app-validation
                            field="epfDetails.uanNumber"
                            [form]="formGroup"
                            [error]="{
                              required: 'This is a mandatory field, Kindly enter UAN number',
                              invalid: 'Invalid UAN number'
                            }"
                          ></app-validation>
                        </div>
                        <div class="col-md-6 col-12 mb-3 pe-0">
                          <label for="inputEmail4" class="form-label">Previous PF Member ID <sup>*</sup> </label>
                          <input
                            type="text"
                            class="form-control"
                            aria-label="Last name"
                            formControlName="previousPFAccountNumber"
                            (input)="validatePFNumber($event)"
                            [ngClass]="{
                              'is-invalid':
                                getControl('epfDetails.previousPFAccountNumber').errors &&
                                getControl('epfDetails.previousPFAccountNumber').touched
                            }"
                            maxlength="22"
                          />
                          <app-validation
                            field="epfDetails.previousPFAccountNumber"
                            [form]="formGroup"
                            [error]="{
                              required: 'This is a mandatory field, Kindly Previous PF Member ID',
                              invalid: 'Invalid Previous PF Member ID'
                            }"
                          ></app-validation>
                        </div>
                      </div>
                      <div class="row px-0">
                        <div class="col-md-6 col-12 mb-3">
                          <label for="inputEmail4" class="form-label" style="white-space: nowrap"
                            >Date of Exit from Previous Employer <sup>*</sup>
                          </label>
                          <input
                            type="date"
                            class="form-control"
                            aria-label="Last name"
                            formControlName="dateOfExitFromPreviousEmployer"
                            [ngClass]="{
                              'is-invalid':
                                getControl('epfDetails.dateOfExitFromPreviousEmployer').errors &&
                                getControl('epfDetails.dateOfExitFromPreviousEmployer').touched
                            }"
                          />
                          <app-validation
                            field="epfDetails.dateOfExitFromPreviousEmployer"
                            [form]="formGroup"
                            [error]="{
                              required: 'This is a mandatory field, Kindly select date of exit from previour employer',
                              invalid: 'Date of exit from previour employer cannot be in future'
                            }"
                          ></app-validation>
                        </div>
                        <div class="col-md-6 col-12 mb-3 pe-0" *ngIf="!isFieldHidden('SCHEME_CERTIFICATE_NUMBER')">
                          <label for="inputEmail4" class="form-label"
                            >Scheme Certificate Number
                            <sup *ngIf="isFieldMandatory('SCHEME_CERTIFICATE_NUMBER')">*</sup></label
                          >
                          <input
                            type="text"
                            class="form-control"
                            aria-label="Last name"
                            formControlName="schemeCertificateNumber"
                            onkeydown="return /[0-9a-zA-Z/]/i.test(event.key)"
                            [ngClass]="{
                              'is-invalid':
                                getControl('epfDetails.schemeCertificateNumber').errors &&
                                getControl('epfDetails.schemeCertificateNumber').touched
                            }"
                            maxlength="12"
                          />
                          <app-validation
                            field="epfDetails.schemeCertificateNumber"
                            [form]="formGroup"
                            [error]="{
                              required: 'This is a mandatory field, Kindly enter Scheme certificate number',

                              invalid: 'Please enter a valid Scheme certificate number'
                            }"
                          ></app-validation>
                        </div>
                      </div>
                      <div class="row px-0">
                        <div class="col-12 p-2 mt-3 ms-2 right-notfctn">
                          <img src="../../../assets/images/svg/calendar-icon.svg" style="float: left; height: 17px" />
                          <span class="mb-2">Note :</span>
                          <div class="notification-scroll-card">
                            <ul class="cursor pad-top-15">
                              <li
                                class="note"
                                *ngFor="let note of configMap.get('EPF_NOTES')?.split('~~~')"
                                [innerHTML]="note"
                              ></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="row px-0">
                        <div
                          #passbookUploadDiv
                          class="col-md-6 col-12 px-0"
                          tabindex="0"
                          *ngIf="!isFieldHidden('UPLOAD_PASSBOOK')"
                        >
                          <div class="p-3 text-center">
                            <div class="col-12 text-start upladtp-txt">
                              <h3>Upload your Passbook <sup *ngIf="isFieldMandatory('UPLOAD_PASSBOOK')">*</sup></h3>
                            </div>
                            <app-multiple-file-selector
                              [isMultiple]="false"
                              [acceptedFormatMsg]="passbookFileAcceptedFormatMsg"
                              [maxAllowedSizeInBytes]="5242880"
                              [inputAccept]="'.pdf, .jpeg, .jpg, .png'"
                              [allowedTypes]="['application/pdf', 'image/jpeg', 'image/png']"
                              (chooseFiles)="uploadedFiles.passbook = $event?.[0]"
                            ></app-multiple-file-selector>
                          </div>
                        </div>
                        <div
                          #pfServiceHistoryScreenshot
                          class="col-md-6 col-12 px-0"
                          *ngIf="!isFieldHidden('UPLOAD_SERVICE_HISTORY_SS')"
                        >
                          <div class="p-3 text-center pe-0">
                            <div class="col-12 text-start upladtp-txt">
                              <h3>
                                Upload PF Service History screenshot
                                <sup *ngIf="isFieldMandatory('UPLOAD_SERVICE_HISTORY_SS')">*</sup>
                              </h3>
                            </div>
                            <app-multiple-file-selector
                              [isMultiple]="false"
                              [acceptedFormatMsg]="pfServiceHistoryScreenshotFileAcceptedFormatMsg"
                              [maxAllowedSizeInBytes]="5242880"
                              [inputAccept]="'.pdf, .jpeg, .png'"
                              [allowedTypes]="['application/pdf', 'image/jpeg', 'image/png']"
                              (chooseFiles)="uploadedFiles.pfServiceHistoryScreenshot = $event?.[0]"
                            ></app-multiple-file-selector>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-xxl-12 col-xl-12 col-lg-9 col-md-7 col-12 px-0 my-3"
                    *ngIf="!isExistingEpfMember"
                    [formGroupName]="GENERATED_UAN_GROUP_NAME"
                  >
                    <div class="row mx-0">
                      <div class="col-12">
                        <div class="static-text form-control mb-3">
                          <p class="m-0 red-text text-center">Generate & Share your UAN</p>
                          <p class="m-0 text-center mb-3">
                            <b>To create your PF account and start your contributions to PF &nbsp;</b>
                          </p>

                          <div class="row mx-0">
                            <div class="col-md-6 col-12 mb-3">
                              <label class="form-label" for=""
                                >Generated UAN <sup *ngIf="isGeneratedUANRequired">*</sup></label
                              >
                              <input
                                type="text"
                                class="form-control"
                                aria-label="UAN"
                                formControlName="generatedUAN"
                                (input)="validateUAN($event)"
                                [ngClass]="{
                                  'is-invalid':
                                    getControl('generatedUANFormGroup.generatedUAN').errors &&
                                    getControl('generatedUANFormGroup.generatedUAN').touched
                                }"
                                maxlength="12"
                              />
                              <app-validation
                                field="generatedUANFormGroup.generatedUAN"
                                [form]="formGroup"
                                [error]="{
                                  required: 'This is a mandatory field, Kindly enter generated UAN number',
                                  invalid: 'Invalid UAN number'
                                }"
                              ></app-validation>
                            </div>
                            <div class="col-md-6 col-12 mb-3 d-flex align-items-end">
                              <a class="underline-link" (click)="openUANModal()"> Steps to Generate your UAN </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div [formGroupName]="EPS_DETAILS_NAME" *ngIf="!isFieldHidden('PENSION_PAYMENT_ORDER_NUMBER')">
                  <div class="row mx-0">
                    <div class="col-md-6 col-12 mb-3 align-self-center rdobtn-dv">
                      <p>Were you already a member of Employee Pension scheme ?</p>
                    </div>
                    <div class="col-md-6 col-12 mb-3 align-self-center">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          [name]="IS_EPS_MEMBER"
                          [value]="true"
                          id="isEPSMember-yes"
                          [formControlName]="IS_EPS_MEMBER"
                        />
                        <label class="form-check-label" for="isEPSMember"> Yes <sup>*</sup> </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          [name]="IS_EPS_MEMBER"
                          [value]="false"
                          id="isEPSMember-no"
                          [formControlName]="IS_EPS_MEMBER"
                        />
                        <label class="form-check-label" for="isEPSMember"> No <sup>*</sup> </label>
                      </div>
                      <a class="underline-link" (click)="openModal()"
                        ><u>Click here to understand your EPS Eligibility</u></a
                      >
                    </div>
                  </div>
                  <div class="row mx-0" *ngIf="getControl('epsDetails.isEPSMember')?.value">
                    <div class="col-md-5 col-12 mb-3">
                      <label for="inputEmail4" class="form-label"
                        >Pension payment Order number
                        <sup *ngIf="isFieldMandatory('PENSION_PAYMENT_ORDER_NUMBER')">*</sup></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        aria-label="Last name"
                        [formControlName]="PENSION_PAYMENT_ORDER"
                        onkeydown="return /[0-9a-zA-Z/]/i.test(event.key)"
                        [ngClass]="{
                          'is-invalid':
                            getControl(EPS_DETAILS_NAME + '.' + PENSION_PAYMENT_ORDER).errors &&
                            getControl(EPS_DETAILS_NAME + '.' + PENSION_PAYMENT_ORDER).touched
                        }"
                        maxlength="12"
                      />
                      <app-validation
                        [field]="EPS_DETAILS_NAME + '.' + PENSION_PAYMENT_ORDER"
                        [form]="formGroup"
                        [error]="{
                          required: 'This is a mandatory field, Kindly enter Pension payment Order Number',

                          invalid: 'Please enter a valid Pension Payment Order Number'
                        }"
                      ></app-validation>
                    </div>
                  </div>
                </div>

                <div
                  [formGroupName]="BANK_DETAILS_NAME"
                  *ngIf="!isFieldHidden('BANK_ACCOUNT_NUMBER') || !isFieldHidden('BANK_IFSC')"
                >
                  <div class="row mx-0">
                    <div class="col-md-6 col-12 mb-3" *ngIf="!isFieldHidden('BANK_ACCOUNT_NUMBER')">
                      <label for="inputEmail4" class="form-label"
                        >Bank Account Number <sup *ngIf="isFieldMandatory('BANK_ACCOUNT_NUMBER')">*</sup>
                        <i
                          class="fa fa-info-circle ms-1 text-muted"
                          data-bs-toggle="tooltip"
                          data-bs-placement="right"
                          title="Please ensure that you add your Aadhaar linked bank account details in your PF account"
                        >
                        </i
                      ></label>
                      <input
                        type="text"
                        class="form-control"
                        aria-label="Bank Account number"
                        [formControlName]="BANK_ACC_NUM"
                        (input)="onInput($event)"
                        maxlength="16"
                        [ngClass]="{
                          'is-invalid':
                            getControl(BANK_DETAILS_NAME + '.' + BANK_ACC_NUM).errors &&
                            getControl(BANK_DETAILS_NAME + '.' + BANK_ACC_NUM).touched
                        }"
                      />
                      <app-validation
                        [field]="BANK_DETAILS_NAME + '.' + BANK_ACC_NUM"
                        [form]="formGroup"
                        [error]="{
                          required: 'This is a mandatory field, Kindly enter Bank Account Number',

                          invalid: 'Please enter a valid Bank Account Number'
                        }"
                      ></app-validation>
                    </div>

                    <div class="col-md-6 col-12 mb-3" *ngIf="!isFieldHidden('BANK_IFSC')">
                      <label for="inputEmail4" class="form-label"
                        >Bank IFSC Code <sup *ngIf="isFieldMandatory('BANK_IFSC')">*</sup></label
                      >
                      <input
                        type="text"
                        class="form-control"
                        aria-label="IFSC code"
                        [formControlName]="BANK_IFSC_CODE"
                        maxlength="11"
                        [ngClass]="{
                          'is-invalid':
                            getControl(BANK_DETAILS_NAME + '.' + BANK_IFSC_CODE).errors &&
                            getControl(BANK_DETAILS_NAME + '.' + BANK_IFSC_CODE).touched
                        }"
                      />
                      <app-validation
                        [field]="BANK_DETAILS_NAME + '.' + BANK_IFSC_CODE"
                        [form]="formGroup"
                        [error]="{
                          required: 'This is a mandatory field, Kindly enter IFSC Code',

                          invalid: 'Please enter a valid IFSC Code'
                        }"
                      ></app-validation>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid px-0">
      <div class="row d-flex justify-content-end p-3 udbtm mx-0">
        <div class="col-md-9 col-12">
          <ul>
            <li>
              <button
                type="button"
                class="btn scbtn margin-right-10"
                (click)="goToDashboard()"
                [routerLink]="dashboardPageLink"
              >
                <i class="fas fa-arrow-left"></i> EXIT TO DASHBOARD
              </button>
            </li>
            <li>
              <button type="button" class="btn psbtn margin-right-10" (click)="moveTo(3)">
                <i class="fas fa-arrow-left"></i> PREVIOUS SECTION
              </button>
            </li>
            <li>
              <button type="button" class="btn scbtn" (click)="moveTo(5)">
                CONTINUE <i class="fas fa-arrow-right"></i>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section *ngIf="currentStep == 5">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12 udsmain">
          <div class="col-12 udprog">
            <div class="udslide">
              <div class="up90"></div>
            </div>
            <div class="udperc">
              <span class="udp9">90% completed</span>
            </div>
          </div>
          <div class="col-12 epfo-mincnt pt-1">
            <div class="col-12 empl-tptxt">
              <h3 class="my-1">Good job! Let's finish off this last step as well</h3>
            </div>
            <div class="row mt-3">
              <div class="col-md-7 col-7 mb-0">
                <h5 class="my-1">Here is your pre-filled Form 11 and 26(6) Declaration:</h5>
                <h5 class="my-1">Download & Upload the signed copy</h5>
              </div>
              <div class="col-md-5 col-5 px-0">
                <div class="row mx-0">
                  <div class="col-12 text-center">
                    <button type="button" class="btn-save df11 my-1" (click)="downloadForm11()">DOWNLOAD</button>
                    <h6 class="text-center small">
                      Note: <span>{{ configMap.get('UPLOAD_FORM_11_NOTE') }}</span>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-4 offset-md-4 col-12 px-0">
                <div class="p-1 text-center">
                  <div class="col-12 text-center upladtp-txt">
                    <h3>Upload the Signed Form here</h3>
                  </div>
                  <app-multiple-file-selector
                    [isMultiple]="false"
                    [acceptedFormatMsg]="form11AcceptedFormatMsg"
                    [inputAccept]="'.pdf'"
                    [allowedTypes]="['application/pdf']"
                    (chooseFiles)="uploadedFiles.form11 = $event?.[0]"
                  ></app-multiple-file-selector>
                </div>
              </div>

              <div class="col-md-12 col-12 px-0">
                <div class="form-check">
                  <div formGroupName="declarationConsent">
                    <label for="consent1" class="consent-text"><strong>Declaration Consent:</strong></label>

                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" formControlName="consent1" id="consent1" />
                      <label class="form-check-label consent-text" for="consent1"
                        ><sup>*</sup>
                        I have read & understood the Employee Pension Scheme eligibility criteria and attended the new
                        joinee PF onboarding session. I am now aware of my EPS eligibility and based on my declaration
                        of EPS eligibility in the form-11, the employer shall contribute & deduct the contribution as
                        applicable from my salary and credit the same in the Employee Pension Fund.
                      </label>
                    </div>

                    <div class="form-check mt-1">
                      <input class="form-check-input" type="checkbox" formControlName="consent2" id="consent2" />
                      <label class="form-check-label consent-text" for="consent2"
                        ><sup>*</sup>
                        I will duly abide by the rules, regulations and amendments and notifications as under the
                        Employee Provident Fund Miscellaneous Provisions Act 1952. I hereby declare that all the above
                        particulars given by me are true to my knowledge.
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid px-0">
      <div class="row d-flex justify-content-end p-3 udbtm mx-0">
        <div class="col-md-9 col-12">
          <ul>
            <li>
              <button
                type="button"
                class="btn scbtn margin-right-10"
                (click)="goToDashboard()"
                [routerLink]="dashboardPageLink"
              >
                <i class="fas fa-arrow-left"></i> EXIT TO DASHBOARD
              </button>
            </li>
            <li>
              <button type="button" class="btn psbtn margin-right-10" (click)="moveTo(4)">
                <i class="fas fa-arrow-left"></i> PREVIOUS SECTION
              </button>
            </li>
            <li>
              <button
                type="button"
                class="btn scbtn"
                (click)="moveTo(6)"
                [disabled]="!uploadedFiles.form11 || !isConsentValid()"
              >
                CONTINUE <i class="fas fa-arrow-right"></i>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section *ngIf="currentStep == 6">
    <div class="container">
      <div class="row mx-0">
        <div class="col-md-6 col-12 confimg">
          <img src="./assets/images/space.png" class="img-fluid" />
        </div>
        <div class="col-md-6 col-12 text-center confbox">
          <div>
            <h3>Wohoo, You have successfully completed the new joinee process!</h3>
            <h3>You will receive a mail with the details of further steps from our team via email.</h3>
            <div class="col-12 text-center">
              <a [routerLink]="activityPageLink" (click)="goToDashboard()">
                <button type="button" class="btn-save scbtn">Finish and go to Dashboard</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</form>

<app-dynamic-modal
  [isVisible]="showModal"
  position="fullscreen"
  title="How is EPS (Employee Pension Scheme) benefit eligibility is determined?"
  [bodyTemplate]="epsContent"
  (close)="closeModal()"
></app-dynamic-modal>

<ng-template #epsContent>
  <p>
    <strong>EPS is not applicable for all employees</strong> and there are some criteria set by EPFO based on which the
    eligibility is decided. Below are the scenario-based criteria for you to determine your pension eligibility based on
    previous employer.
  </p>

  <p>
    Incorrectly declaring EPS eligibility will lead to claim rejections in the future, and it is a tedious process to
    get it corrected later with EPFO. Such incorrect declaration may result in imposing penalties on employer and
    employee too. Hence declaring right benefit category is significant.
  </p>
  <div class="table-responsive">
    <table class="table table-bordered mb-1">
      <thead class="table-light">
        <tr>
          <th>Scenario</th>
          <th>Your 1st Employment Start Date</th>
          <th>Your Monthly Wage Limit</th>
          <th>Have you done Full Withdrawal of PF?</th>
          <th>Your EPS Eligibility Status is</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Scenario 1</td>
          <td>Before Sept’2014</td>
          <td>Any wage</td>
          <td>No</td>
          <td>Eligible for Pension</td>
        </tr>
        <tr>
          <td>Scenario 2</td>
          <td>Before Sept’2014</td>
          <td>
            10k in Company ‘A’ <br />
            20k in Company ‘B’
          </td>
          <td class="text-wrap">Yes and joined another company (B) with wage above 15k after Sept 2014</td>
          <td class="text-wrap">Eligible in Company ‘A’ but not Eligible for Pension in company ‘B’</td>
        </tr>
        <tr>
          <td>Scenario 3</td>
          <td>After Sept’2014</td>
          <td>Wage is ABOVE 15k</td>
          <td>No</td>
          <td>Not Eligible for Pension</td>
        </tr>
        <tr>
          <td>Scenario 4</td>
          <td>After Sept’2014</td>
          <td>Wage is BELOW 15k</td>
          <td>No</td>
          <td>Eligible for Pension</td>
        </tr>
      </tbody>
    </table>
  </div>

  <p class="fst-italic .pt-0 mb-0">*Monthly wage refers to your monthly basic + Dearness allowance</p>
  <p class="mb-1">Note :</p>
  <ol>
    <li>
      If full withdrawal is done anytime during your employment tenure, then the next company you are joining will be
      considered as 1st employment & eligibility is decided based on above criteria.
    </li>
    <li>
      We will not be able to tag you as EPS member if your previous employer has tagged you incorrectly as not eligible.
      It must be rectified first.
    </li>
  </ol>
</ng-template>

<app-dynamic-modal
  [isVisible]="showUANodal"
  position="centered"
  title="Steps to generate UAN"
  [bodyTemplate]="generateUANContent"
  (close)="closeUANModal()"
></app-dynamic-modal>

<ng-template #generateUANContent>
  <ul class="list-points">
    <li>Download <b>Umang</b> and Aadhaar <b>Face RD</b> App in your mobile</li>
    <li>
      Setup the Umang App and search for <b>“EPFO Services”</b> and click on <b>“UAN Allotment and Activation”</b>
    </li>
    <li>Enter your Aadhaar number & it will prompt you to complete Face Authentication.</li>
    <li>
      Once the scan is successful, the system will fetch your details and generate a new UAN. You will receive a
      confirmation message <b>“Aadhaar Face Authentication is successful” </b>
    </li>
    <li>Share the generated UAN</li>
  </ul>
  <p>
    Note: In case you are getting any application related or server errors, keep trying again at a later point of time
  </p>
</ng-template>
